import { render, staticRenderFns } from "./EraSombria.vue?vue&type=template&id=3900a87c&"
import script from "./EraSombria.vue?vue&type=script&lang=js&"
export * from "./EraSombria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports